(function () {

    angular
        .module('smartertoolsApp')
        .directive('stLoginRequiredNotice', [stLoginRequiredNotice]);

    function stLoginRequiredNotice() {
        return {
            templateUrl: '/app/global/components/st-login-required-notice.html'
        };
    }

})();